import historyHandler from "jd-library/historyHandler"
import OtpVerification from "jd-library/OtpVerification"
import SliderWrapper from "jd-library/SliderWrapper"
import React, { useEffect, useState, useRef } from "react"
import style from "./verify-mobile-number.scss"
import { connect, useDispatch } from "react-redux"
import { sendOTP, editDeliveryBoy, createDeliveryBoy } from "../utils"
import { showMessage } from "jd-library/src/Toast/ToastAction"
import toastMessageActions from "jd-library/toastMessageActions"

function VerifyMobileNumber(props) {
	const token = props.session.token
	const dispatch = useDispatch()
  let [leftIcons, setLeftIcon] = useState([
    {
      className: "icon-HDRback",
      onClick: () => {
        props.otpSetFlag && props.otpSetFlag()
      },
    },
  ])
  let [rightIcons, setRightIcon] = useState(
    props.isMobile
      ? []
      : [
          {
            className: "icon-HDRcross",
            onClick: () => {
              currentState.current = "fail"
              //props.callBack && props.callBack.failCB({ closeAll: true })
              props.otpSetFlag && props.otpSetFlag()
            },
          },
        ]
  )
  const [header, setHeader] = useState("Verify Mobile Number")
  let mobileNumber = props.mobileNumber ? props.mobileNumber : ""
  const currentState = useRef("initial")
  const [attempts, setAttemptCount] = useState(1)
  const maxAttempt = props.response ? 5 : 10
  const docid = props.session.docId ? props.session.docId : ""
  const [otpUrls, updateUrl] = useState({
    sendOtp: {
      url: `/vendorapis/delivery_boy/delivery/sendOtp?mobile=${mobileNumber}&token=${token}`,
      data: {
        mobile: mobileNumber,
        token,
      },
      method: "GET",
    },
    verfiyOtp: {
      url: `/vendorapis/delivery_boy/delivery/verifyOtp`,
      data: {
        otp: window.otp,
        token,
      },
      method: "GET",
    },
  })

  let viewOptions = {
    customHtml: `<div class="opt-txt text-para-one"><div class="otp-verify-img"><img src="https://image1.jdomni.in/jdomni_email/014_SmsOtp.svg"></div>We have sent an OTP verification to this number.</div><div><div class="mobile-holder"> <span class="highlight-text">+91  ${mobileNumber}</span> </div></div>`,
    codeText: "Enter Code",
  }
  // if (!props.isMobile) {
  viewOptions.showSubmit = true,
  viewOptions.submitBtnText = window.otp ? "Continue" : "Save",
  viewOptions.buttonProps = {
    className: "submit-btn",
      variant: "primary",
  }
  // }

  useEffect(() => {
    sendOTP({
      token,
      mobile: mobileNumber,
    })
    if (maxAttempt == 0) {
      handleComplete("fail")
    }
  }, [])

  //Creates response for sending OTP url
  const handleSend = (response) => {
    if(response && response.result &&
      response.result.results &&
      response.result.results.code === 0 &&
      response.result.results.msg == "OTP Sent!"){
        return {
          errors: { code: 0, msg: "" },
          results: { sent: true },
        }
    }else if(response &&
      response.results &&
      response.results.code === 0 &&
      response.results.msg == "OTP Sent!"){
        return {
          errors: { code: 0, msg: "" },
          results: { sent: true },
        }
    }
  }

  //handles the otp and generates URL before sending the otp for verification
  const getOTP = (otp) => {
    if (otp) {
      window.enteredOtp = otp
      let verfiyOtp = {
        url: `/vendorapis/delivery_boy/delivery/verifyOtp`,
        data: {
          otp: otp,
          token,
        },
      }
      let dummyUrl = {
        ...otpUrls,
        verfiyOtp,
      }
      updateUrl(dummyUrl)
    }
    return otp
  }

  //Generates the response after verification
  const handleVerify = (response) => {
    if (response.results && !response.results.code) {
      return {
        errors: { code: 0, msg: "" },
        results: {
          match: true,
          islimit: false,
          expire: false,
          vCodeFailCnt: 0,
        },
      }
    } else {
      setAttemptCount(attempts + 1)
      return {
        errors: { code: 0, msg: response.msg },
        results: {
          match: false,
          islimit: false,
          expire: false,
          vCodeFailCnt: attempts,
        },
      }
    }
  }

  //Handles the response once the otp is verified/failed.
  const handleComplete = async (status) => {
    if (status == "fail") {
      currentState.current = "fail"
      setHeader("Verification Unsuccessful")
      let dummyLeftIcon = props.isMobile
        ? []
        : [
            {
              className: "icon-HDRback",
              onClick: () => {
                props.otpSetFlag && props.otpSetFlag()
              },
            },
          ]
      let dummyRightIcon = [
        {
          className: "icon-HDRcross",
          onClick: () => {
            props.otpSetFlag && props.otpSetFlag()
          },
        },
      ]
      setLeftIcon(dummyLeftIcon)
      setRightIcon(dummyRightIcon)
    } else if ((status = "success")) {
      currentState.current = "success"
      const { name, imageurl } = props

      /*if(props.editData && props.editData.mobile)
      {
          //console.log('edit',props)
          editDeliveryBoy({docid,name,mobile,imageurl})
      }*/
      let res = await createDeliveryBoy({
        token,
        name,
        mobile: mobileNumber,
        imageurl: imageurl|| "",
			} )
			dispatch(
        toastMessageActions.showMessage({
					type:'info',
          message: res?.data?.errors?.msg || res?.data?.results?.msg || "",
        })
			)
			props.otpSetFlag && props.otpSetFlag("success")
    }
  }

  return (
    <SliderWrapper
      header={{
        heading: header,
        className: style["header"],
        leftIcons,
        rightIcons,
      }}
      slider={{
        className: style["verify-mobile-number"],
      }}
      onHidden={() => {
        if (currentState.current == "initial") {
          props.otpSetFlag && props.otpSetFlag()
        }
      }}
    >
      <OtpVerification
        className={style["otp-slider"]}
        input={mobileNumber}
        sendRequest={otpUrls.sendOtp}
        onSend={(response) => handleSend(response)}
        otpFormatter={(otp) => {
          return getOTP(otp)
        }}
        otpKey={"otp"}
        verifyRequest={otpUrls.verfiyOtp}
        onVerify={(response) => handleVerify(response)}
        onComplete={(status) => {
          handleComplete(status)
        }}
        otpLength={4}
        // buttonObj={buttonObject}
        view={viewOptions}
        showCustomHtml={true}
        maxAttempts={maxAttempt}
        sendOnMount={false}
        isDelBoyFlow={true}
        verificationFailedClass={"staff-verfication-failed"}
      ></OtpVerification>
    </SliderWrapper>
  )
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    isMobile: state.library.deviceData.isMobile,
    session: state.session,
  }
}
export default connect(mapStateToProps, {})(VerifyMobileNumber)
